module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en-us":{"andThen":"and then","whatElse":"What else needs to be automated?","integrations":{"navigate":{"title":"Navigate to integrations settings?","message":"Connect {name} to Keap within settings. Once connected, available automation triggers will appear in the list. A draft will be saved of this automation.","confirm":"Manage integrations"}}}}')
  delete Component.options._Ctor
}
